<div class="row">
    <div class="col-12 align-self-center">
        <div class="form-group text-center">
            <label for="sortida-input"><b>Sortida</b></label>
            <input id="sortida-input" (ngModelChange)="change($event)" [(ngModel)]="sortida" placeholder="000000" type="text" name="sortida" class="form-control">
            <p class="text-danger" *ngIf="error">{{error}}</p>
        </div>
    </div>
</div>
